import XLSX from 'sheetjs-style';
import axios from 'axios';
import { SDLUtil } from '@/utils';

const XlsxPopulate = require('xlsx-populate');

export default {
  install(Vue, options) {
    Vue.extract = function (headers, data, target, options, usePassword, sheetNames) {
      let wbOptions = null;
      if (usePassword) {
        const password = SDLUtil.generateUUID(); 
        let promptPw = null;
        if (target === 'Contact List' || target === 'Admin User List') {
          const promptPIIMessage = 'Personal information handlers have an obligation to delete personal data once they are no longer required for the purposes';
          promptPw = prompt(`${promptPIIMessage}\n\n Copy to password: `, password);
        } else {
          promptPw = prompt('Copy to password: ', password);
        }

        if (promptPw == null) {
          return;
        }
        if (promptPw.length < 1) {
          alert('Please input the password');
          return;
        }
        wbOptions = {
          password: promptPw !== password ? promptPw : password,
        };
      }

      const body = {
        target,
      };
      axios.post(`${SDLUtil.API_URL}/rwd-admin/check/excel`, body).then(
        response => {
          const wb = XLSX.utils.book_new();
          let wsNames = sheetNames;
          if (!wsNames || wsNames.length === 0) {
            wsNames = ['Sheet1'];
          }
          wsNames.forEach(sheetName => {
            const wsData = data[sheetName] ? data[sheetName] : data;
            let header = [];
            if (headers instanceof Array) {
              header = headers;
            } else {
              header = headers[sheetName];
            }
            const ws = XLSX.utils.json_to_sheet(wsData, {
              header,
              skipHeader: false,
            });
            const colMaxLength = {};
            Object.entries(ws).forEach(entity => {
              const item = entity[0];
              const value = entity[1].v;
              const type = entity[1].t;
              if (type === 'n') {
                if (value.toString().indexOf('.') > -1) {
                  entity[1].z = '#,##0.##';
                } else {
                  entity[1].z = '#,##0';
                }
              } else if (type === 's') {
                entity[1].z = '@';
              }
              let len = 0;
              if (item !== '!ref') {
                const col = item.replace(/[0-9]/gi, '');
                const num = item.replace(/[A-Z]/gi, '');
                // if header
                if (num === '1') {
                  entity[1].s = {
                    font: {
                      sz: 10,
                      bold: true,
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'center',
                      wrapText: '1',
                    },
                  };
                } else {
                  entity[1].s = {
                    font: {
                      sz: 10,
                    },
                    alignment: {
                      vertical: 'center',
                      wrapText: '1',
                    },
                  };
                }
                switch (type) {
                  case 's':
                    len = value.length > 50 ? 50 : value.length + 1;
                    break;
                  default:
                    len = 20;
                    break;
                }
                if (!colMaxLength[col]) {
                  colMaxLength[col] = len;
                }
                colMaxLength[col] = Math.max(colMaxLength[col], len);
              }
            });
            const cols = Object.keys(colMaxLength).sort();
            const worksheetCols = [];
            cols.forEach(c => {
              worksheetCols.push({ width: colMaxLength[c] });
            });
            ws['!cols'] = worksheetCols;
            XLSX.utils.book_append_sheet(wb, ws, sheetName);
            if (options != null) {
              const range = XLSX.utils.decode_range(ws['!ref']);
              options.forEach(element => {
                const { prefix } = element;
                const startRow = element.startRow ? element.startRow : 2;
                for (let j = startRow; j <= range.e.r + 1; j++) {
                  const ref = prefix + j;
                  ws[ref].t = element.t ? element.t : ws[ref].t;
                  ws[ref].z = element.z ? element.z : ws[ref].z;
                }
              });
            }
          });
          const wout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'array' });
          const fileName = `${target} Export(${Vue.getCurrent().toFormat('yyyyMMddHHmmss')}).xlsx`;
//          console.log(wout);
//          console.log(fileName);
//          const url = window.URL.createObjectURL(new Blob([wout]));
//          const a = document.createElement('a');
//          document.body.appendChild(a);
//          a.href = url;
//          a.download = fileName;
//          a.click();
//          window.URL.revokeObjectURL(url);
//          document.body.removeChild(a);
          console.log(149);
  const loaderObj = true;// Vue.$loading.show();

          XlsxPopulate.fromDataAsync(wout)
            .then(workbook => {
              workbook.outputAsync(wbOptions)
                .then((blob) => {
 //                   console.log(139);
                    //loaderObj.hide();
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  document.body.appendChild(a);
                  a.href = url;
                  a.download = fileName;
                  a.click();
                  window.URL.revokeObjectURL(url);
                  document.body.removeChild(a);
                  console.log(149);
                });
            }); 

        },
        error => {
          alert(error.data.errorMessage ? error.data.errorMessage : 'Failed - export file');
          console.log(error);
        },
      );
    };
  },
};



// WEBPACK FOOTER //
// ./src/utils/excelExtract.js